// extracted by mini-css-extract-plugin
export var navHeight = "64";
export var navPencilbarHeight = "48";